import BaseApiClient from '../BaseApiClient';
import type { BulkImport } from '@/interfaces/BulkImport.interface';

export class ApiBulkImport extends BaseApiClient {
  async get<TResult>(id: number): Promise<BulkImport<TResult>> {
    return this.client
      .get(`/bulk-imports/${id}`, { headers: { Version: '2025-11-14' } })
      .then((response) => response.data);
  }
}

export async function waitForBulkImportResult<TResult>(
  initialBulkImport: BulkImport<TResult> | TResult,
  getBulkImport: (id: number) => Promise<BulkImport<TResult>>
): Promise<TResult> {
  if (
    !(
      typeof initialBulkImport === 'object' &&
      initialBulkImport !== null &&
      'id' in initialBulkImport &&
      'status' in initialBulkImport
    )
  ) {
    return initialBulkImport as TResult;
  }

  let bulkImport = initialBulkImport;

  while (
    bulkImport.status === 'queued' ||
    bulkImport.status === 'processing'
  ) {
    await new Promise((resolve) => window.setTimeout(resolve, 1500));
    bulkImport = await getBulkImport(bulkImport.id);
  }

  if (bulkImport.status === 'failed' || !bulkImport.result) {
    throw new Error(bulkImport.error_message ?? 'Unable to process import.');
  }

  return bulkImport.result;
}
